import View from "../framework/view";
import Server from "../server";
import {GrapesTemplate} from "../bo/page";
import jQuery from "jquery";
import css, {AtRule, Comment, Rule} from "css";

import grapesjs, {Asset, Component, Editor, ToHTMLOptions} from 'grapesjs';
import gjsBlockBasic from 'grapesjs-blocks-basic';
import {Spinner} from "./spinner";
import Alerts from "../misc/alerts";

const classname = "template-editor-view";

const server = Server.instance();

export class TemplateEditor extends View {

    private path: string;

    private template?: GrapesTemplate;

    private initialising = false;

    private editor?: Editor;

    private google_api_key = "";

    constructor(path: string) {
        super(classname);
        this.path = path;
        this.init();
    }

    async init() {
        this.template = await Server.instance().template(this.path.split(/\\/));
        this.google_api_key = await server.getMapsAPIKey();
        await this.configureEditor();
    }

    toTemplate() : GrapesTemplate {

        const editor = this.editor as Editor;

        const pm = editor.getProjectData();
        delete pm.assets;
        const template = JSON.stringify(pm);
        const cssString = editor.getCss() || "";
        const html = editor.getHtml({tag: "div"});

        const tree = css.parse(cssString);

        const prefix = `.template-${this.path.replace(/\//g, "-")}`;

        const fix = (rule: Rule) => {
            if (rule.selectors) {
                for (let i = 0; i < rule.selectors.length; i++) {
                    rule.selectors[i] = `${prefix} ${rule.selectors[i]}`;
                }
            }
        }

        const fixRules = (rules: Array<Rule | Comment | AtRule>) => {
            for (const rule of rules) {
                if (rule.type == "rule") {
                    fix(rule);
                }
                if (rule.type == "media" && rule.rules) {
                    fixRules(rule.rules);
                }
            }
        }


        if (tree.stylesheet) {
            fixRules(tree.stylesheet.rules);
        }

        const cssStringPrefxed = css.stringify(tree);

        return {
            css: cssStringPrefxed,
            html: html,
            template: template
        }

    }

    protected render0(): JQuery<HTMLElement> {

        const html = `
<div class="panel__top">
  <div class="panel__basic-actions"></div>
  <div class="panel__devices"></div>
  <div class="panel__switcher"></div>
</div>
<div class="editor-row">
  <div class="editor-canvas">
    <div id="${this.getUuid()}-gjs" class="tp-editor-container"></div>
  </div>
  <div class="panel__right">
    <div class="layers-container"></div>
    <div class="styles-container"></div>
    <div class="traits-container"></div>
    <div class="blocks-container"></div>
  </div>
</div>
`;
        const out = jQuery(html);

        this.afterUpdate(() => {
            this.configureEditor();
        });

        return out;
    }

    private async configureEditor() {
        if (! this.template) {
            return;
        }

        // handle repaint of parent
        if (this.initialising) {
            return;
        }
        this.initialising = true;

        const google_api_key = this.google_api_key;

        const elt = this.elt();
        if (elt.data("init") || this.editor) {
            return;
        }
        elt.data("init", true);

        const containerId = `#${this.getUuid()}-gjs`;

        const G = await import("grapesjs");
        const B = await import("grapesjs-blocks-basic");

        const collections = await server.collections();

        // @ts-ignore
        await import("grapesjs/dist/css/grapes.min.css");

        /*
        const grapesjs = G.grapesjs;
        const gjsBlockBasic = B.default;
        */

        const assets = await server.assets();

        // convert from our assets to grapesjs assets

        const grapesAssets: any[] = assets.map(asset => {
            return {
                type: "image",
                src: asset.web_url,
                height: asset.height,
                width: asset.width,
                name: asset.name,
                category: asset.category || "original"
            }
        });

        let projectData = undefined;
        if (this.template.template) {
            const dataStr = (this.template && this.template.template) || "{}";
            projectData = JSON.parse(dataStr);
        } else {
            const html = this.template.html;
            if (html) {
                jQuery(containerId).html(html);
            }
        }

        const galleryComponentType = (editor: Editor) => {

            editor.TraitManager.addType("tp-colour", {

                createInput({ trait }) {

                    const el = document.createElement('div');
                    el.innerHTML = `<input type="color">`;
                    return el;
                },

                onEvent({ elInput, component }) {
                    const color = jQuery(elInput).find("input").val();
                    component.addAttributes({ "style": `color: ${color};`});
                },

                onUpdate({ elInput, component }) {
                    const el = component.view?.el;
                    if (el) {
                        const style = getComputedStyle(el);

                        // rgb(a,b,c) format
                        const color = style.color;

                        if (color) {
                            const match = color.match(/rgba?\(([0-9]+), *([0-9]+), *([0-9]+).*/);
                            if (match) {
                                function componentToHex(c: string) {
                                    var hex = (+c).toString(16);
                                    return hex.length == 1 ? "0" + hex : hex;
                                }
                                function rgbToHex(r: string, g: string, b: string) {
                                    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
                                }
                                const hexcolor = rgbToHex(match[1], match[2], match[3]);
                                jQuery(elInput).find("input").val(hexcolor);
                            }
                        }
                    }
                },
            });

            editor.Components.addType("heading1", {
                isComponent: (el) => {
                    return el.tagName == "H1"
                },
                extend: "text",
                model: {
                    defaults: {
                        tagName: "h1",
                        content: "Insert title here",
                        droppable: false,
                        traits: [
                            {
                                type: "tp-colour",
                                name: "color",
                                label: "Colour"
                            }
                        ]
                    },
                }
            });

            editor.Components.addType("link-droppable", {
                isComponent: (el) => {
                    return el.tagName == "A"
                },
                extend: "link",
                model: {
                    defaults: {
                        droppable: true,
                    },
                }
            });

            const renderMasonry = (el: HTMLElement, model: Component) => {
                const elt = jQuery(el);
                elt.addClass("thumb").addClass("thumb-img");

                const src = model.get("src");

                elt.attr("style", `background-image: url(${src})`);
                elt.find("img").attr("src", src);
            };

            editor.Components.addType("masonryimage", {
                isComponent: (el) => {
                    return el.className == "thumb-img";
                },
                model: {
                    defaults: {
                        tagName: "a",
                        src: null,
                        title: null,
                        droppable: false,
                        draggable: ".masonry",
                        components: [
                            {
                                tagName: "img",
                            }
                        ]
                    },
                    init() {
                        const me = this;
                        const { em } = this;
                        const am = em?.Assets;

                        if (am && ! me.get("src")) {
                            am.open({
                                select: (asset, complete) => {
                                    if (asset) {
                                        console.log(`selected asset`, asset);
                                        const src = asset.getSrc();
                                        const name = asset.getFilename();
                                        me.set("src", src);
                                        me.set("title", name);
                                    }
                                    complete && am.close();
                                },
                                target: this,
                                types: ['image'],
                                accept: 'image/*',
                            });
                        }
                    },
                    toHTML(opts?: ToHTMLOptions) {
                        const a = jQuery("<a><img /></a>");
                        renderMasonry(a[0], this);
                        const html = a[0].outerHTML;
                        return html;
                    }
                },
                view: {
                    tagName: () => {
                        return "a";
                    },
                    onRender({ el, model }) {
                        console.log(`onRender el=${el} model=${model}`, el, model);
                        const render = (el: HTMLElement) => {

                            renderMasonry(el, model);

                        };
                        render(el);
                        model.on("change", (c) => {
                            const component = c as Component;
                            const view = component.getView();
                            const el = view?.el;
                            if (el) {
                                render(el);
                            }
                        });
                    },
                }
            });

            editor.Components.addType("gallery", {
                isComponent: (el) => el.tagName == "TP-GALLERY",
                model: {
                    defaults: {
                        tagName: "tp-gallery",
                        droppable: false,
                        attributes: {
                            "data-slug": "all-products"
                        },
                        traits: [
                            {
                                type: "select",
                                name: "data-slug",
                                label: "Collection",
                                options: collections.map((c) => {
                                    return {
                                        "id": c.slug as string,
                                        "label": c.name as string
                                    }
                                })
                            }
                        ],
                    },
                    attributes: { type: 'text', required: true },
                },
                view: {
                    tagName: () => {
                        return "iframe";
                    },
                    onRender({ el, model }) {
                        const render = (el: HTMLElement) => {
                            const iframe = jQuery(el);
                            const slug = (el.getAttribute("data-slug") as string) || "all-products";
                            const url = `web/gallery/${encodeURIComponent(slug)}`;
                            iframe.attr("src", url);
                            iframe.css("width", "100%");
                            iframe.css("height", "800px");
                        };
                        render(el);
                        model.on("change:attributes", (c) => {
                            const component = c as Component;
                            const view = component.getView();
                            const el = view?.el;
                            if (el) {
                                render(el);
                            }
                        });
                    },
                }
            });

            editor.Components.addType("contactform", {
                isComponent: (el) => el.tagName == "TP-CONTACTFORM",
                model: {
                    defaults: {
                        tagName: "tp-contactform",
                        droppable: false,
                    },
                    attributes: { type: 'text', required: true },
                },
                view: {
                    tagName: () => {
                        return "div";
                    },
                    onRender({ el, model }) {
                        const render = (el: HTMLElement) => {
                            const div = jQuery(el);
                            div.text("Contact form goes here");
                        };
                        render(el);
                    },
                }
            });

            editor.Components.addType("contactmap", {
                isComponent: (el) => el.tagName == "TP-CONTACTMAP",
                model: {
                    defaults: {
                        tagName: "tp-contactmap",
                        droppable: false,
                    },
                    attributes: { type: 'text', required: true },
                },
                view: {
                    tagName: () => {
                        return "iframe";
                    },
                    onRender({ el, model }) {
                        const render = (el: HTMLElement) => {
                            const place = "West Row Botanica, Canberra";
                            const iframe = jQuery(el);
                            const url = `https://www.google.com/maps/embed/v1/place?key=${google_api_key}&q=${encodeURIComponent(place)}`;
                            iframe.attr("src", url);
                            iframe.attr("class", "contactmap");
                            iframe.css("width", "100%");
                            iframe.css("height", "800px");
                        };
                        render(el);
                        model.on("change:attributes", (c) => {
                            const component = c as Component;
                            const view = component.getView();
                            const el = view?.el;
                            if (el) {
                                render(el);
                            }
                        });
                    },
                }
            });

        };

        // @ts-ignore
        const editorConfig: EditorConfig = {
            // Indicate where to init the editor. You can also pass an HTMLElement
            container: containerId,
            // Get the content for the canvas directly from the element
            // As an alternative we could use: `components: '<h1>Hello World Component!</h1>'`,
            fromElement: true,
            plugins: [ gjsBlockBasic, galleryComponentType ],
            pluginsOpts: {
                // @ts-ignore
                [gjsBlockBasic]: {
                    blocks: ["column1", "column2", "column3", "text", "image"]
                }
            },
            // Size of the editor
            height: '800px',
            width: 'auto',
            blockManager: {
                appendTo: '.blocks-container',
            },
            layerManager: {
                appendTo: '.layers-container',
            },
            assetManager: {
                upload: "api/website/assets",
            },
            // We define a default panel as a sidebar to contain layers
            panels: {
                defaults: [
                    {
                        id: 'layers',
                        el: '.panel__right',
                        // Make the panel resizable
                        resizable: {
                            maxDim: 950,
                            minDim: 200,
                            tc: false, // Top handler
                            cl: true, // Left handler
                            cr: false, // Right handler
                            bc: false, // Bottom handler
                            // Being a flex child we need to change `flex-basis` property
                            // instead of the `width` (default)
                            keyWidth: 'flex-basis',
                        },
                    },
                    {
                        id: 'panel-switcher',
                        el: '.panel__switcher',
                        buttons: [
                            {
                                id: 'show-blocks',
                                active: true,
                                label: 'Blocks',
                                command: 'show-blocks',
                                togglable: false,
                            },
                            {
                                id: 'show-layers',
                                active: true,
                                label: 'Layers',
                                command: 'show-layers',
                                // Once activated disable the possibility to turn it off
                                togglable: false,
                            },
                            {
                                id: 'show-traits',
                                active: true,
                                label: 'Traits',
                                command: 'show-traits',
                                togglable: false,
                            },
                            {
                                id: 'show-style',
                                active: true,
                                label: 'Styles',
                                command: 'show-styles',
                                togglable: false,
                            },
                        ],
                    },
                    {
                        id: 'panel-devices',
                        el: '.panel__devices',
                        buttons: [
                            {
                                id: 'device-desktop',
                                label: 'D',
                                command: 'set-device-desktop',
                                active: true,
                                togglable: false,
                            },
                            {
                                id: 'device-mobile',
                                label: 'M',
                                command: 'set-device-mobile',
                                togglable: false,
                            },
                        ],
                    },
                ],
            },
            selectorManager: {
                appendTo: '.styles-container',
            },
            styleManager: {
                appendTo: '.styles-container',
                sectors: [
                    {
                        name: "General",
                        open: true,
                        buildProps: [
                            "font-size",
                            "color",
                            "background-color",
                            "box-shadow",
                            "text-align",
                        ],
                    },
                    {
                        name: "Margins",
                        open: false,
                        buildProps: [
                            "margin-left",
                            "margin-right",
                            "margin-top",
                            "margin-bottom"
                        ]
                    },
                    {
                        name: "Borders",
                        open: false,
                        buildProps: [
                            "border-style",
                            "border-width",
                            "border-radius",
                        ]
                    },
                    {
                        name: "Dimensions",
                        open: false,
                        buildProps: [
                            "width",
                            "min-width",
                            "max-width",
                            "height",
                            "min-height",
                            "max-height",
                            "padding"
                        ],
                    },
                ],
            },
            traitManager: {
                appendTo: '.traits-container',
            },
            deviceManager: {
                devices: [
                    {
                        name: 'Desktop',
                        width: '', // default size
                    },
                    {
                        name: 'Mobile',
                        width: '320px', // this value will be used on canvas width
                        widthMedia: '480px', // this value will be used in CSS @media
                    },
                ],
            },
            storageManager: {
                type: 'local', // Type of the storage, available: 'local' | 'remote'
                autosave: true, // Store data automatically
                autoload: false, // Autoload stored data on init
                stepsBeforeSave: 1, // If autosave enabled, indicates how many changes are necessary before store method is triggered
                options: {
                    local: {
                        // Options for the `local` type
                        key: 'gjsProject', // The key for the local storage
                    },
                },
            },
            canvas: {
                styles: [
                    "web/index.css",
                    "sass/template-editor.css"
                ]
            },
            richTextEditor: {
                onPaste: ({ ev, rte }) => {
                    ev.preventDefault();
                    const { clipboardData } = ev;
                    if (clipboardData) {
                        const text = clipboardData.getData("html");
                        let html = clipboardData.getData("text/html");

                        if (text && ! html) {
                            html = html = text.replace(/(?:\r\n|\r|\n)/g, "<br/>");
                        }

                        if (html) {
                            // Clean up

                            console.log(`clean up input`, html);
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, "text/html");

                            const h = jQuery(doc.body);

                            h.find("head").remove();

                            const styled = h.find("*[style]");
                            styled.each((index, element) => {
                                jQuery(element).removeAttr("style");
                            });

                            let iters = 0;
                            while (iters < 20) {
                                iters ++; // avoid loop in case of error
                                const font = h.find("font");
                                if (font.length == 0) {
                                    break;
                                }
                                font.each((index, element) => {
                                    const inner = element.innerHTML;
                                    const span = document.createElement("span");
                                    span.innerHTML = inner;
                                    element.replaceWith(span);
                                });
                            }
                            html = h[0].outerHTML;
                        }

                        rte.exec("insertHTML", html);
                    }
                }
            }
        };
        const editor = this.editor = grapesjs.init(editorConfig);

        editor.Panels.addPanel({
            id: 'panel-top',
            el: '.panel__top',
        });
        editor.Panels.addPanel({
            id: 'basic-actions',
            el: '.panel__basic-actions',
            buttons: [
                {
                    id: 'visibility',
                    active: true, // active by default
                    className: 'btn-toggle-borders',
                    label: '<u>B</u>',
                    command: 'sw-visibility', // Built-in command
                },
                {
                    id: 'export',
                    className: 'btn-open-export',
                    label: 'Exp',
                    command: 'export-template',
                    context: 'export-template', // For grouping context of buttons from the same panel
                },
                {
                    id: 'show-json',
                    className: 'btn-show-json',
                    label: 'JSON',
                    context: 'show-json',
                    command(editor: any) {
                        const components = editor.getComponents();
                        const j = JSON.stringify(components);
                        editor.Modal.setTitle('Components JSON')
                            .setContent(
                                `<textarea style="width:100%; height: 250px;">
            ${j}
          </textarea>`,
                            )
                            .open();
                    },
                },
            ],
        });

        // Define commands
        editor.Commands.add('show-layers', {
            getRowEl(editor: any) {
                return editor.getContainer().closest('.editor-row');
            },
            getLayersEl(row: any) {
                return row.querySelector('.layers-container');
            },

            run(editor, sender) {
                const lmEl = this.getLayersEl(this.getRowEl(editor));
                lmEl.style.display = '';
            },
            stop(editor, sender) {
                const lmEl = this.getLayersEl(this.getRowEl(editor));
                lmEl.style.display = 'none';
            },
        });
        editor.Commands.add('show-styles', {
            getRowEl(editor: any) {
                return editor.getContainer().closest('.editor-row');
            },
            getStyleEl(row: any) {
                return row.querySelector('.styles-container');
            },

            run(editor: any, sender: any) {
                const smEl = this.getStyleEl(this.getRowEl(editor));
                smEl.style.display = '';
            },
            stop(editor: any, sender: any) {
                const smEl = this.getStyleEl(this.getRowEl(editor));
                smEl.style.display = 'none';
            },
        });

        editor.Commands.add('show-traits', {
            getTraitsEl(editor: any) {
                const row = editor.getContainer().closest('.editor-row');
                return row.querySelector('.traits-container');
            },
            run(editor, sender) {
                this.getTraitsEl(editor).style.display = '';
            },
            stop(editor, sender) {
                this.getTraitsEl(editor).style.display = 'none';
            },
        });

        editor.Commands.add('show-blocks', {
            getBlocksEl(editor: any) {
                const row = editor.getContainer().closest('.editor-row');
                return row.querySelector('.blocks-container');
            },
            run(editor, sender) {
                this.getBlocksEl(editor).style.display = '';
            },
            stop(editor, sender) {
                this.getBlocksEl(editor).style.display = 'none';
            },
        });


        editor.Commands.add('set-device-desktop', {
            run: (editor) => editor.setDevice('Desktop'),
        });
        editor.Commands.add('set-device-mobile', {
            run: (editor) => editor.setDevice('Mobile'),
        });

        const bm = editor.BlockManager;


        bm.add("heading1", {
            label: "Heading 1",
            category: "Basic",
            activate: true,
            content: `<h1>Insert heading here</h1>`
        });
        bm.add("heading2", {
            label: "Heading 2",
            category: "Basic",
            activate: true,
            content: `<h2>Insert heading here</h2>`
        });
        bm.add("heading3", {
            label: "Heading 3",
            category: "Basic",
            activate: true,
            content: `<h3>Insert heading here</h3>`
        });

        bm.add("link-droppable", {
            label: "Link",
            category: "Basic",
            activate: true,
            media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z" />
      </svg>`,
            content: {
                type: "link-droppable",
                content: "",
                style: { color: "#d983a6" }
            }
        });

        bm.add("gallery", {
            label: "Gallery",
            category: "Basic",
            activate: true,
            content: {
                type: "gallery",
            }
        });

        bm.add("page", {
            label: "Page with margins",
            category: "Basic",
            activate: true,
            content: `<div class="responsive-page"><div>Insert page here</div></div>`
        });

        bm.add("masonrygallery", {
            label: "Flowing image container",
            category: "Basic",
            activate: true,
            content: `<div class="masonry"><div>Insert images here</div></div>`
        });

        bm.add("masonryimage", {
            label: "Flowing image",
            category: "Basic",
            activate: true,
            content: {
                type: "masonryimage",
            }
        });

        bm.add("grid", {
            label: "Grid 3 columns",
            category: "Basic",
            activate: true,
            attributes: {
                height: "300px"
            },
            content: `<div class="responsive-grid"><div>Insert grid items here</div></div>`
        });

        bm.add("contact-form", {
            label: "Contact form",
            category: "Basic",
            activate: true,
            content: {
                type: "contactform"
            }
        });

        bm.add("contact-map", {
            label: "Map",
            category: "Basic",
            activate: true,
            content: {
                type: "contactmap"
            }
        });

        if (projectData) {
            editor.loadProjectData(projectData);
        }

        const am = editor.AssetManager;

        const originalToWebMap : any = {};

        for (const asset of grapesAssets) {
            am.add(asset);
        }

        let urlRemap: { [original:string]: string} = {};

        const urlToAsset: { [url:string] : Asset } = {};

        function calcUrlRemap() {

            const originalToWeb = (url: string) => url && url.replace(/\.webp$/, "-web.webp");
            const assets = am.getAll();

            const allUrls: any = {};
            const origUrls: string[] = [];
            assets.forEach((a: any /* Asset */) => {
                const src = a.getSrc();
                urlToAsset[src as string] = a;
                const category = a.get("category");
                allUrls[src] = src;
                if (category == "original") {
                    origUrls.push(src);
                }
            });

            urlRemap = {};
            origUrls.forEach((orig) => {
                const remapped =  originalToWeb(orig);
                if (allUrls[remapped]) {
                    urlRemap[orig] = remapped;
                }
            });

            console.log(`urlRemap=`, urlRemap)
        }

        calcUrlRemap();

        let spinner : any = undefined;

        editor.on("asset:upload:start", () => {
            spinner = Spinner.pushSpinner();
        });

        editor.on("asset:upload:end", () => {
            spinner && spinner();
        });

        editor.on("asset:upload:error", (err) => {
            spinner && spinner();
            Alerts.alert("Upload failed");
        });

        editor.on("component:update:src", (model : Component) => {
            console.log(`update ${model.tagName}`);
            if (model.tagName.toUpperCase() != "IMG") {
                return;
            }
            const atts = model.getAttributes();

            const src = atts["src"];
            calcUrlRemap();

            if (src) {
                const remap = urlRemap[src];
                if (remap && src != remap) {
                    atts["src"] = remap;
                }
                const asset = urlToAsset[src];
                if (asset) {
                    const h = asset.attributes["height"];
                    const w = asset.attributes["width"];
                    if (h && w) {
                        const style = model.getStyle();
                        style["aspect-ratio"] = `${w}/${h}`;
                        model.setStyle(style);
                    }
                }
            }
            model.setAttributes(atts);
        });

        function renderOriginal() {
            const am = editor.AssetManager;
            const all = am.getAll();
            const original = all.filter((a : Asset) => {
                const category = a.get("category");
                const ok = category == "original" || ! category;
                return ok;
            });

            am.render(original);
        }

        editor.on("asset:add", (err) => {
            renderOriginal();
        });

        editor.on("asset:open", (err) => {
            const am = editor.AssetManager;
            renderOriginal();
        });

        renderOriginal();

        if (true) {
            const all = editor.StyleManager.getBuiltInAll();
            console.log("built in properties", all);
        }

    }
}


